import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { SettingsForm } from '@/pages/settings/components/SettingsForm.tsx';
import { useTranslation } from 'react-i18next';
import { PageWithLayout } from '@/models/page';
import { Permission } from '@/models/user';

const Settings: PageWithLayout = () => {
    const { t } = useTranslation();

    return (
        <>
            <Helmet>
                <title>{t('generalSettings')}</title>
            </Helmet>

            <SettingsForm />
        </>
    );
};

Settings.isProtected = true;
Settings.permissions = [Permission.GENERAL_SETTINGS_NAV];
Settings.getLayout = (Component) => <SidebarLayout>{Component}</SidebarLayout>;

export default Settings;
